<template>
<div class="wrapper">
<section class="top_banner" :style="{ 'background-image': 'url(' + imageBanner + ')' }">
  <wv-flex :gutter="0" class="banner_container banner_industry">
    <wv-flex-item>
      <div class="headline">多行业、多容器的专业解决方案</div>
      <div class="text">KHS生产线由多种优质、创新的设备组成：不论标准化的解决方案还是个性化的定制方案， KHS都将为您提供竭诚服务。</div>
    </wv-flex-item>
  </wv-flex>
</section>
<section class="main-content industry">
  <div class="industry text-center">请选择您所属的行业</div>
  <wv-flex :gutter="10" class="industry-list">
    <wv-flex-item class="industry-item">
      <div class="industry-click" v-on:click="greet" data-id="1">
        <i class="icon icon-1-beer-default"></i>
        <div class="info">啤酒</div>
      </div>
    </wv-flex-item>
    <wv-flex-item class="industry-item">
      <div class="industry-click" v-on:click="greet" data-id="2">
        <i class="icon icon-2-water-default"></i>
        <div class="info">水</div>
      </div>
    </wv-flex-item>
    <wv-flex-item class="industry-item">
      <div class="industry-click" v-on:click="greet" data-id="3">
        <i class="icon icon-3-drink-default"></i>
        <div class="info">软饮料</div>
      </div>
    </wv-flex-item>
  </wv-flex>
  <div class="industry-info-section full_width" data-id="1">
    <div class="industry-summary">KHS啤酒灌装系统简洁节能、洁净卫生，从灌装、杀菌、贴标、包装、码垛以及检测，KHS为您提供整线的一站式服务。</div>
    <div class="industry-notify">请选择您希望使用的容器</div>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIcon01" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶 <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIcon05" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIcon03" alt=""></div>
        <div class="text">
          <span class="title">桶装 <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIcon04" alt=""></div>
        <div class="text">
          <span class="title">桶装<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIcon05" alt=""></div>
        <div class="text">
          <span class="title">PET <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIcon06" alt=""></div>
        <div class="text">
          <span class="title">PET<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
  </div>
  <div class="industry-info-section full_width" data-id="2">
    <div class="industry-summary">KHS都能为您的水产品，提供个性化瓶形的灌装解决方案。</div>
    <div class="industry-notify">请选择您希望使用的容器</div>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconWaterGlassNoReturn" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶 <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconWaterGlassReturn" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconWaterPETNoReturn" alt=""></div>
        <div class="text">
          <span class="title">PET <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconWaterPETReturn" alt=""></div>
        <div class="text">
          <span class="title">PET<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconWaterCans" alt=""></div>
        <div class="text">
          <span class="title">易拉罐</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half" style="visibility: hidden">
        <div class="img_container"><img :src="imageIcon06" alt=""></div>
        <div class="text">
          <span class="title">PET</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
  </div>
  <div class="industry-info-section full_width" data-id="3">
    <div class="industry-summary">不管采用何种包装形式，KHS均能为您提供正确的整线系统，让您不仅可以快速安全灌装、包装您的产品，同时节能环保。</div>
    <div class="industry-notify">请选择您希望使用的容器</div>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconSoftDrinkGlassNoReturn" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶 <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconSoftDrinkGlassReturn" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconSoftDrinkPETNoReturn" alt=""></div>
        <div class="text">
          <span class="title">PET <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconSoftDrinkPETReturn" alt=""></div>
        <div class="text">
          <span class="title">PET<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconSoftDrinkKegNoReturn" alt=""></div>
        <div class="text">
          <span class="title">桶 <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconSoftDrinkKegReturn" alt=""></div>
        <div class="text">
          <span class="title">桶<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconSoftDrinkCans" alt=""></div>
        <div class="text">
          <span class="title">易拉罐</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half" style="visibility: hidden;">
        <div class="img_container"><img :src="imageIconSoftDrinkKegReturn" alt=""></div>
        <div class="text">
          <span class="title">桶</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
  </div>
  <!-- second -->
  <wv-flex :gutter="10" class="industry-list">
    <wv-flex-item class="industry-item">
      <div class="industry-click" v-on:click="greet" data-id="4">
        <i class="icon icon-4-milk-default"></i>
        <div class="info">牛奶/乳制品</div>
      </div>
    </wv-flex-item>
    <wv-flex-item class="industry-item">
      <div class="industry-click" v-on:click="greet" data-id="5">
        <i class="icon icon-5-juice-default"></i>
        <div class="info">果汁/茶饮料</div>
      </div>
    </wv-flex-item>
    <wv-flex-item class="industry-item">
      <div class="industry-click" v-on:click="greet" data-id="6">
        <i class="icon icon-6-wine-default"></i>
        <div class="info">烈性酒类</div>
      </div>
    </wv-flex-item>
  </wv-flex>
  <div class="industry-info-section full_width" data-id="4">
    <div class="industry-summary">KHS历经多年无数次试验和实践，根据您的需要定制ESL牛奶，含乳饮料和乳酸菌饮料的灌装系统，保证整个灌装环节无菌和卫生。</div>
    <div class="industry-notify">请选择您希望使用的容器</div>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconMilkPETNoReturn" alt=""></div>
        <div class="text">
          <span class="title">PET <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half" style="visibility: hidden;">
        <div class="img_container"><img :src="imageIcon05" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
  </div>
  <div class="industry-info-section full_width" data-id="5">
    <div class="industry-summary">从温和的无泡排气工艺到精准的浓缩处理，再到热灌装，我们创新工艺技术会帮助您灌装优质、流行的茶饮果汁产品。</div>
    <div class="industry-notify">请选择您希望使用的容器</div>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconJuiceGlassNoReturn" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶 <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconJuiceGlassReturn" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconJuicePETNoReturn" alt=""></div>
        <div class="text">
          <span class="title">PET <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconJuicePETReturn" alt=""></div>
        <div class="text">
          <span class="title">PET<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIcon06" alt=""></div>
        <div class="text">
          <span class="title">易拉罐</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half" style="visibility: hidden">
        <div class="img_container"><img :src="imageIcon06" alt=""></div>
        <div class="text">
          <span class="title">易拉罐</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
  </div>
  <div class="industry-info-section full_width" data-id="6">
    <div class="industry-summary">专为高端酒类提供定制化优质灌装方案。</div>
    <div class="industry-notify">请选择您希望使用的容器</div>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconWine" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶 <br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half" style="visibility: hidden;">
        <div class="img_container"><img :src="imageIcon05" alt=""></div>
        <div class="text">
          <span class="title">玻璃瓶<br>(可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
  </div>
  <!-- second end -->
  <!-- third -->
  <wv-flex :gutter="10" class="industry-list">
    <wv-flex-item class="industry-item">
      <div class="industry-click" v-on:click="greet" data-id="7">
        <i class="icon icon-7-oil-default"></i>
        <div class="info">食品</div>
      </div>
    </wv-flex-item>
    <wv-flex-item class="industry-item">
      <div class="industry-click" v-on:click="greet" data-id="8">
        <i class="icon icon-8-chemical-default"></i>
        <div class="info">非食品</div>
      </div>
    </wv-flex-item>
    <wv-flex-item class="industry-item">
      <!--<div class="industry-click" v-on:click="greet" data-id="9">-->
        <!--<i class="icon icon-6-wine-default"></i>-->
        <!--<div class="info">烈性酒类</div>-->
      <!--</div>-->
    </wv-flex-item>
  </wv-flex>
  <div class="industry-info-section full_width" data-id="7">
    <div class="industry-summary">面向食品领域，KHS为您提供卫生、灵活的食品灌装系统。</div>
    <div class="industry-notify">请选择您希望使用的容器</div>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconFoodPETNoReturn" alt=""></div>
        <div class="text">
          <span class="title">PET<br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconFoodPouches" alt=""></div>
        <div class="text">
          <span class="title">Pouches<br>(袋装)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
  </div>
  <div class="industry-info-section full_width" data-id="8">
    <div class="industry-summary">非食品行业对灵活的瓶形和设计均有高要求，不论汽油，液体清洁剂，柔软剂或类似产品，KHS非食品的PET瓶灌装生产线为您提供尖端技术，最高效率和设备使用寿命期。</div>
    <div class="industry-notify">请选择您希望使用的容器</div>
    <wv-flex :gutter="0" class="industry-content-list">
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconNonFoodPETNoReturn" alt=""></div>
        <div class="text">
          <span class="title">PET<br>(不可回收)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
      <wv-flex-item class="industry-item is-half">
        <div class="img_container"><img :src="imageIconFoodPouches" alt=""></div>
        <div class="text">
          <span class="title">Pouches<br>(袋装)</span>
          <span class="scope">建议适用范围</span>
        </div>
      </wv-flex-item>
    </wv-flex>
  </div>
  <!--<div class="industry-info-section full_width" data-id="9">-->
    <!--<div class="industry-summary">专为高端酒类提供定制化优质灌装方案</div>-->
    <!--<div class="industry-notify">请选择您希望使用的容器</div>-->
    <!--<wv-flex :gutter="0" class="industry-content-list">-->
      <!--<wv-flex-item class="industry-item is-half">-->
        <!--<div class="img_container"><img :src="imageIcon01" alt=""></div>-->
        <!--<div class="text">-->
          <!--<span class="title">玻璃瓶 <br>(不可回收)</span>-->
          <!--<span class="scope">建议适用范围</span>-->
        <!--</div>-->
      <!--</wv-flex-item>-->
      <!--<wv-flex-item class="industry-item is-half">-->
        <!--<div class="img_container"><img :src="imageIcon05" alt=""></div>-->
        <!--<div class="text">-->
          <!--<span class="title">玻璃瓶<br>(可回收)</span>-->
          <!--<span class="scope">建议适用范围</span>-->
        <!--</div>-->
      <!--</wv-flex-item>-->
    <!--</wv-flex>-->
    <!--<wv-flex :gutter="0" class="industry-content-list">-->
      <!--<wv-flex-item class="industry-item is-half">-->
        <!--<div class="img_container"><img :src="imageIcon03" alt=""></div>-->
        <!--<div class="text">-->
          <!--<span class="title">桶装 <br>(不可回收)</span>-->
          <!--<span class="scope">建议适用范围</span>-->
        <!--</div>-->
      <!--</wv-flex-item>-->
      <!--<wv-flex-item class="industry-item is-half">-->
        <!--<div class="img_container"><img :src="imageIcon04" alt=""></div>-->
        <!--<div class="text">-->
          <!--<span class="title">桶装<br>(可回收)</span>-->
          <!--<span class="scope">建议适用范围</span>-->
        <!--</div>-->
      <!--</wv-flex-item>-->
    <!--</wv-flex>-->
    <!--<wv-flex :gutter="0" class="industry-content-list">-->
      <!--<wv-flex-item class="industry-item is-half">-->
        <!--<div class="img_container"><img :src="imageIcon05" alt=""></div>-->
        <!--<div class="text">-->
          <!--<span class="title">PET <br>(不可回收)</span>-->
          <!--<span class="scope">建议适用范围</span>-->
        <!--</div>-->
      <!--</wv-flex-item>-->
      <!--<wv-flex-item class="industry-item is-half">-->
        <!--<div class="img_container"><img :src="imageIcon06" alt=""></div>-->
        <!--<div class="text">-->
          <!--<span class="title">PET<br>(可回收)</span>-->
          <!--<span class="scope">建议适用范围</span>-->
        <!--</div>-->
      <!--</wv-flex-item>-->
    <!--</wv-flex>-->
  <!--</div>-->
  <!-- third end -->
</section>
</div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'IndustryPage',
  mounted: function () {
    this.$nextTick(function () {
    })
  },
  data () {
    return {
      imageBanner: 'static/images/bg-banner-industry.jpg',
      imageIcon01: 'static/images/1-1-icon.png',
      imageIcon02: 'static/images/1-2-icon.png',
      imageIcon03: 'static/images/1-3-icon.png',
      imageIcon04: 'static/images/1-4-icon.png',
      imageIcon05: 'static/images/1-5-icon.png',
      imageIcon06: 'static/images/1-6-icon.png',
      imageIconWine: 'static/images/industry-icon_wine-default@3x.png',
      imageIconJuiceGlassReturn: 'static/images/industry-icon_juice_glass_return.svg',
      imageIconJuiceGlassNoReturn: 'static/images/industry-icon_juice_glass_noreturn.svg',
      imageIconJuicePETNoReturn: 'static/images/industry-icon_juice_pet_noreturn.svg',
      imageIconJuicePETReturn: 'static/images/industry-icon_juice_pet_return.svg',
      imageIconSoftDrinkGlassNoReturn: 'static/images/industry-icon_softdrink_glass_noreturn.svg',
      imageIconSoftDrinkGlassReturn: 'static/images/industry-icon_softdrink_glass_return.svg',
      imageIconSoftDrinkPETNoReturn: 'static/images/industry-icon_softdrink_pet_return.svg',
      imageIconSoftDrinkPETReturn: 'static/images/industry-icon_softdrink_pet_return.svg',
      imageIconSoftDrinkKegNoReturn: 'static/images/industry-icon_softdrink_kegs_noreturn.svg',
      imageIconSoftDrinkKegReturn: 'static/images/industry-icon_softdrink_kegs_return.svg',
      imageIconSoftDrinkCans: 'static/images/industry-icon_softdrink_cans.svg',
      imageIconWaterGlassNoReturn: 'static/images/industry-icon_water_glass_noreturn.svg',
      imageIconWaterGlassReturn: 'static/images/industry-icon_water_glass_noreturn.svg',
      imageIconWaterPETNoReturn: 'static/images/industry-icon_water_pet_noreturn.svg',
      imageIconWaterPETReturn: 'static/images/industry-icon_water_pet_return.svg',
      imageIconWaterCans: 'static/images/industry-icon_softdrink_cans.svg',
      imageIconMilkPETNoReturn: 'static/images/industry-icon_milk_pet_noreturn.svg',
      imageIconFoodPETNoReturn: 'static/images/industry-icon_food_pet_noreturn.svg',
      imageIconFoodPouches: 'static/images/industry-icon_food_pouches.svg',
      imageIconNonFoodPETNoReturn: 'static/images/industry-icon_nonfood_pet_noreturn.svg'
    }
  },
  methods: {
    greet: function (event) {
      // `this` 在方法里指向当前 Vue 实例
      // alert('Hello ' + this.classList + '!')
      // `event` 是原生 DOM 事件

      $('.industry-click').removeClass('active')
      $('.industry-click').each(function () {
        let iconItem = $(this).children('i')
        iconItem.attr('class', iconItem.attr('class').replace('enable', 'default'))
      })

      let currentNode = $(event.currentTarget)
      let currentItemId = currentNode.attr('data-id')
      let currentIconNode = currentNode.children('i')
      let currentSrcClass = currentIconNode.attr('class')
      let currentTargetClass = currentSrcClass.replace('default', 'enable')

      currentIconNode.attr('class', currentTargetClass)
      currentNode.addClass('active')

      $('.industry-info-section').removeClass('active')
      $('.industry-info-section').each(function () {
        let thisItemId = $(this).attr('data-id')
        if (thisItemId === currentItemId) {
          $(this).addClass('active')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.industry-list {
  text-align: center;

  .industry-click {
    display: inline-block;
    padding: 10px;
    border-bottom: 2px solid transparent;
    font-size: 14px;

    &.active {
      color: #009ee3;

      border-bottom: 2px solid #009ee3;
    }
  }
}
.industry-info-section {
  margin-top: -1px;
  background: #eaedf2;
  padding: 25px 24px 30px;
  font-size: 12px;
  text-align: center;
  color: #54585a;
  border-top: 1px solid #e4f3fb;
  display: none;
  &.active {
    display: block;
  }

  .industry-notify {
    color: #a9abac;
    margin-top: 10px;
    margin-bottom: 5px;
  }
}
.industry-content-list {
  padding: 5px 0;

  .weui-flex__item {
    text-align: center;

    &.industry-item {
      position: relative;
      background: #ffffff;
      padding: 15px;

      &:first-child {
        margin-right: 5px;
      }

      &:last-child {
        margin-left: 5px;
      }

      .img_container {
        width: 32px;
        position: absolute;
        top: 50%;
        left: 6px;
        margin-top: -16px;
      }

      .text {
        padding-left: 26px;
        text-align: left;

        .title {
          font-size: 12px;
          display: block;
        }

        .scope {
          color: #a9abac;
          font-size: 11px;
          display: none;
        }
      }
    }
  }

  .is-half {
    width: 50%;
  }
}

.industry {
  .text-center {
    margin: 15px 0;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IndustryPage.vue